document.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll('.figs-nav__item.has-mega-menu');

  items.forEach((item) => {
    const trigger = item.querySelector('[data-figs-trigger]');
    const panel = item.querySelector('[data-figs-panel]');

    if (!trigger || !panel) return;

    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      const isOpen = item.classList.contains('is-open');

      items.forEach((other) => {
        other.classList.remove('is-open');
        const otherTrigger = other.querySelector('[data-figs-trigger]');
        if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
      });

      if (!isOpen) {
        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });

    panel.addEventListener('click', (event) => {
      event.stopPropagation();
    });
  });

  document.addEventListener('click', () => {
    items.forEach((item) => {
      item.classList.remove('is-open');
      const trigger = item.querySelector('[data-figs-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      items.forEach((item) => {
        item.classList.remove('is-open');
        const trigger = item.querySelector('[data-figs-trigger]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
    }
  });
});